import { Component } from 'react'
import { Link } from 'react-router-dom'
import Table from '../../../components/table'
import ApproveModal from './approve-modal'
import RepproveModal from '../candidate/repprove-modal'
import searchIcon from '../../../../assets/icons/search.png'
import filterIcon from '../../../../assets/icons/filter.png'
import infoIcon from '../../../../assets/icons/info.png'
import storageIcon from '../../../../assets/icons/storage.png'
import checkIcon from '../../../../assets/icons/check.png'
import badgeIcon from '../../../../assets/icons/badge.png'
import deleteIcon from '../../../../assets/icons/delete-white.png'
import { listJobs } from '../../../../insfrastructure/services/jobs'
import { listJobApplies } from '../../../../insfrastructure/services/job-applies'
import { StaticValues } from '../../../../insfrastructure/services/static_values'
import { withRouter } from '../../../../insfrastructure/utils/with-router-component'
import moment from 'moment'
import './styles.sass'
import { formatDate } from '../../../../insfrastructure/utils/date-formatter'

class Candidates extends Component<any> {
  state: any = {
    offer: {},
    candidates: {
      data: [],
      count: 0,
      attended_count: 0
    },
    offset: 0,
    jobapply_status: {},
    marital_status: {},
    selectedApprovedCandidate: null,
    selectedRepprovedCandidate: null,
    selectedCandidateForInterview: null,
    loading: false,
    search: ''
  }

  componentDidMount() {
    this.retriveJob();
    this.listCandidates({});
    this.getStaticValues();
  }

  retriveJob = async () => {
    try {
      const offer = (await listJobs({ id: this.props.params.offer_id })).data[0];
      this.setState({ offer });
    } catch (error) {
    }
  }

  listCandidates = async (params: Record<string, any>) => {
    try {
      this.setState({ loading: true });

      const candidates: any = {
        data: [],
        count: 0,
        attended_count: 0
      };
      
      const response = await listJobApplies(this.props.params.offer_id);

      candidates.data = response;
      candidates.count = response.length;
      candidates.attended_count = response.filter(x => x.status !== 'applied').length;

      this.setState({ candidates });
      
      setTimeout(() => {
        this.setState({ loading: false }); 
      }, 1000);
    } catch (error) {
      setTimeout(() => {
        this.setState({ loading: false }); 
      }, 500);
    }
  }

  getStaticValues = async () => {
    try {  
      setTimeout(() => {
        const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;
        const jobapply_status = staticValues.jobapply_status;
        const marital_status = staticValues.marital_status;
        const disability = staticValues.disability;
        
        this.setState({ jobapply_status, marital_status, disability }); 
      }, 1000);
    } catch (error) {}
  }

  getCandidateAge = (date_of_birth_string: string) => {
    var current_date = moment();
    var date_of_birth = moment(date_of_birth_string);
    var years = current_date.diff(date_of_birth, 'years');
    
    return years;
  }

  onSearch = async () => {
    this.listCandidates({ search: this.state.search });
  }

  toggleApproveCandidateModal = (candidate?: any) => {
    this.setState({ selectedApprovedCandidate: candidate });
  }

  onCandidateApproved = async () => {
    this.toggleApproveCandidateModal();
    this.props.navigate('/offers');
  }

  toggleRepproveCandidateModal = (candidate?: any) => {
    this.setState({ selectedRepprovedCandidate: candidate });
  }

  onCandidateRepproved = async () => {
    this.listCandidates({});
    this.toggleRepproveCandidateModal();
  }

  toggleCallForInterviewModal = (candidate?: any) => {
    this.setState({ selectedCandidateForInterview: candidate ? candidate : null });
  }

  onCandidateCalledForInterview = async () => {
    this.setState({ selectedCandidateForInterview: null });
  }

  render() {
    return (
      <div className='job-candidates company-page'>
        <div className='block'>
            <div className='block-header'>
              <div className='title'>
                <img src={storageIcon} alt='storage-icon' />
                <h3><Link to={'/offers'}>Vagas {'>'}</Link> {this.state.offer?.jobTitle?.name} - Candidatos</h3>
              </div>
            </div>
            <div className='general-vision'>
              <div className='data'>
                <h3>Visão Geral</h3>
                <h4>Candidatos: <b>{this.state.candidates.count}</b></h4>
                <h4>Atendidos: <b>{this.state.candidates.attended_count}</b></h4>
              </div>
              <div className='graph-container'>
                <CircularChart percentage={!this.state.loading ? this.state.candidates.attended_count / this.state.candidates.count * 100 : 0} />
                <h4>Atendidos</h4>
              </div>
            </div>
            <div className='searcher'>
              <img className='search-icon' src={searchIcon} alt='search-icon' onClick={this.onSearch} />
              <input type='text' placeholder='Pesquisar candidato' onChange={e => this.setState({ search: e.target.value })} />
              <img className='filter-icon' src={filterIcon} alt='filter-icon' />
            </div>
            <div className='candidates'>
              <Table
                data={this.state.candidates.data}
                total={this.state.candidates.count}
                limit={10}
                offset={this.state.offset}
                loading={this.state.loading}
                onNavigate={(params: any) => {
                  // listCandidates({ offset: params.offset, search });
                }}
                header={
                  <thead>
                    <tr>
                      <th className='name'>Nome do candidato:</th>
                      <th className='basic-info'>Dados básicos:</th>
                      <th className='pcd'>PcD?</th>
                      <th className='date'>Atualização da candidatura:</th>
                      <th className='actions'></th>
                    </tr>
                  </thead>
                }
                body={
                  (candidates: any) => {                    
                    return candidates.map(
                      (candidate: any, index: number) =>
                          <tr key={'candidate_'+index} className={['rejected', 'not_fit'].includes(candidate.status) ? 'not-hired' : ''}>
                            <td>{candidate.name}</td>
                            <td>
                              <p>
                                {this.state.marital_status[candidate.marital_status]}
                                {candidate.date_of_birth && ', ' + this.getCandidateAge(candidate.date_of_birth) + ' anos'}
                              </p>
                              <p>{candidate.city_display_name}</p>
                            </td>
                            <td>{this.state.disability[candidate.has_disabilities]}</td>
                            <td>
                              {<span>{formatDate(candidate.status_updated_at)}</span>}
                            </td>
                            <td>
                              <div className='actions'>
                                <Link to={'/offers/'+this.props.params.offer_id+'/candidates/'+candidate.id} state={{ offer_id: this.props.params.offer_id }}>
                                  <button className='access'>
                                    <img src={infoIcon} alt='info-icon' />
                                    <span>Conheça o candidato {candidate.id}</span>
                                  </button>
                                </Link>
                                {['applied'].includes(candidate.status) &&
                                <span className='status applied'>
                                  <img src={badgeIcon} alt='badge-icon' />
                                  <span>Aplicado</span>
                                </span>}
                                {['interview'].includes(candidate.status) &&
                                <>
                                  <button className='remove' onClick={() => this.toggleRepproveCandidateModal(candidate)}>
                                    <img src={deleteIcon} alt='delete-icon' />
                                    <span>Reprovado</span>
                                  </button>
                                  <button className='hire' onClick={() => this.toggleApproveCandidateModal(candidate)}>
                                    <img src={checkIcon} alt='check-icon' />
                                    <span>Aprovado</span>
                                  </button> 
                                </>}
                                {['hired'].includes(candidate.status) &&
                                <span className='status hired'>
                                  <img src={badgeIcon} alt='badge-icon' />
                                  <span>Contratado</span>
                                </span>}
                                {['rejected'].includes(candidate.status) &&
                                <span className='status not-hired'>
                                  <img src={deleteIcon} alt='delete-icon' />
                                  <span>Reprovado</span>
                                </span>}
                                {['not_fit'].includes(candidate.status) &&
                                <span className='status not-hired'>
                                  <img src={deleteIcon} alt='delete-icon' />
                                  <span>Não Apto</span>
                                </span>}
                              </div>
                            </td>
                          </tr>
                  )}
                }/>
            </div>
        </div>
        <ApproveModal
        render={this.state.selectedApprovedCandidate}
        candidate={this.state.selectedApprovedCandidate}
        jobapply_id={this.state.selectedApprovedCandidate?.id}
        onClose={this.toggleApproveCandidateModal}
        onSubmitted={this.onCandidateApproved} />
        <RepproveModal
        status='rejected'
        render={this.state.selectedRepprovedCandidate}
        candidate={this.state.selectedRepprovedCandidate}
        jobapply_id={this.state.selectedRepprovedCandidate?.id}
        onClose={this.toggleRepproveCandidateModal}
        onSubmitted={this.onCandidateRepproved} />
      </div>
    )
  }
}

export default withRouter(Candidates)

export const CircularChart = ({ percentage }: { percentage: number }) => {
  return (
    <svg width={100} height={100} viewBox="0 0 36 36">
      <path className="circle-bg" style={{
         fill: 'none',
         stroke: '#E6E6E6',
         strokeWidth: 2.5
      }}
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <path
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
        fill="none"
        stroke="#9FD67B"
        strokeWidth="2.5"
        strokeDasharray={`${percentage}, 100`}
        style={{ transition: '0.5s' }}
      />
      <text x="50%" y="50%" textAnchor="middle" fill="black" fontSize="8px" dy=".3em">{percentage}%</text>
    </svg>
  )
}
